import { InjectionToken } from '@angular/core';

export const SVG_SPRITE_URL = new InjectionToken('SVG_SPRITE_URL');
